module.exports = __webpack_public_path__ + "public/Icons/playIcon.svg?2a6a7e17";